module.exports = __webpack_public_path__ + "img/bar.fa98e411.png";